import React from 'react';
import { Breadcrumb, Grid, Icon, Menu, Tab, TabPane } from 'semantic-ui-react';
import styled from 'styled-components';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { loginRedirectAction } from '../../actions/LoginActions';
import Entregas from './Entregas';
import Formulario from './Formulario';

function EspacoTrack(props) {

    const { isloading, userid } = props;

    const StyledTab = styled(Tab)`
&&& {

  .ui.tabular.menu .item{
      font-size:10px !important;
      height:10px !important;
  }
  .ui.menu{
    min-height: 0.0em !important;
  }

 }`

    let panes = [];

    
        panes.push(
            {
                menuItem: <Menu.Item key='TAB2'><Icon name='file alternate' size='large' />Formulário Checklist</Menu.Item>,
                render: () =>
                    <Tab.Pane>
                        <Formulario />
                    </Tab.Pane>


            },
        )

    panes.push({
        menuItem: <Menu.Item key='TAB1'><Icon name='truck' />Entregas</Menu.Item>,
        render: () => (
            <TabPane loading={isloading}>
                <Entregas />
            </TabPane>
        )
    })



    return (
        <div style={{ padding: '1em 0' }}>
            <Menu stackable size='mini' style={{ background: 'transparent', border: 'none', borderBottom: 'solid 1.5px #1884af', boxShadow: 'none', borderRadius: '0 0 5px 5px' }}>
                <Menu.Item>
                    <Breadcrumb size='mini'>
                        <Breadcrumb.Section href="/Home">Home</Breadcrumb.Section>
                        <Breadcrumb.Divider icon='right chevron' />
                        <Breadcrumb.Section active>Espaco Track</Breadcrumb.Section>
                    </Breadcrumb>
                </Menu.Item>
            </Menu>


            <Grid columns={1} doubling>
                <Grid.Column>
                    <StyledTab panes={panes} />
                </Grid.Column>
            </Grid>


                <style>{`

                    /*-------------------------------*/
                    /*Menu Superior*/


                    .ui.mini.menu>.item{
                        padding: 0;
                    }

                    .ui.breadcrumb .section {
                        padding: 1.5em 1.5em !important;
                    }
                    
                    .ui.breadcrumb .section:first-child {
                        padding-right: 0 !important;
                        border-radius: 0 0 0 5px !important;
                    }
                        

                    .ui.breadcrumb .active.section {
                        background-color: #1884af !important;
                        color: #fff !important;
                    }
                `}</style>
            
        </div>
    );
}

const mapStateToProps = (state) => ({
    isloading: state.EspacoTrackReducer.isLoading,
    userid: state.LoginReducer.userid
})


export default withRouter(connect(mapStateToProps, {
    loginRedirectAction
}
)(EspacoTrack));
